import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, ApiError } from '../lib/api';
import type { Admin } from '../lib/types';

export function useAuth() {
  const queryClient = useQueryClient();
  const { data: admin, isLoading } = useQuery<Admin | null>({
    queryKey: ['auth', 'me'],
    queryFn: async () => {
      try { return await api.get<Admin>('/auth/me'); }
      catch (error) {
        if (error instanceof ApiError && error.status === 401) return null;
        throw error;
      }
    },
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
  const login = useMutation({
    mutationFn: (input: { email: string; password: string }) => api.post<Admin>('/auth/login', input),
    onSuccess: (data) => queryClient.setQueryData(['auth', 'me'], data),
  });
  const logout = useMutation({
    mutationFn: () => api.post('/auth/logout'),
    onSuccess: () => { queryClient.clear(); queryClient.setQueryData(['auth', 'me'], null); },
  });
  return { admin: admin ?? null, isLoading, login, logout, isAuthenticated: Boolean(admin) };
}
